import React from "react";
import { useBranding } from "../context/BrandingContext";
import { useNavigate } from "react-router-dom";

const SuccessPaymentComponents = () => {
  const { colors } = useBranding();
  const navigate = useNavigate();

  return (
    <div>
      <div class="success-container">
        <div class="icon-success">
          <svg
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>

        <h1>Payment Successful</h1>
        <p>Thank you! Your payment has been processed successfully.</p>

        {/* <div class="summary">
      <p><strong>Transaction ID:</strong> #TXN123456789</p>
      <p><strong>Amount:</strong> ₹1,499.00</p>
      <p><strong>Date:</strong> 30 July 2025</p>
    </div> */}

        <button onClick={() => navigate("/dashboard")} class="btn" style={{ backgroundColor: colors?.buttonBg, color: colors?.textWhite }}>
          Go to Dashboard
        </button>
      </div>
    </div>
  );
};

export default SuccessPaymentComponents;
